// extracted by mini-css-extract-plugin
export default {"knob":"Knob_knob__8t9cw","dial":"Knob_dial__YAu8-","label":"Knob_label__fQ+Ae","scale":"Knob_scale__IdzI3","scales":"Knob_scales__iSXn9","value":"Knob_value__Lkxao"};